import { AuthPageContainer } from '../../../Components/Page/AuthPageContainer/AuthPageContainer'
import { useRegister } from './useRegister'
import { InputText } from '../../../Components/Fields/InputText'
import { Form, FormikProvider } from 'formik'
import { InputPassword } from '../../../Components/Fields/InputPassword'
import { FilledSuccessButton } from '../../../Components/Buttons/FilledSuccessButton'
import { InputB2CRole } from '../../../Components/Fields/InputB2CRole/InputB2CRole'
import React from 'react'
import { Select } from 'antd'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../routes'

export const Register = () => {
  const { registerFormik, isLoading } = useRegister()

  return (
    <AuthPageContainer subTitle="Sign up and let's get started">
      <FormikProvider value={registerFormik}>
        <Form>
          <div className="w-full mt-5 space-y-5">
            <InputText name="name" label="Name" />
            <InputText name="email" label="E-mail" />
            <InputPassword name="password" label="Password" />
            <InputPassword name="passwordAgain" label="Confirm Password" />
            <InputText name="companyName" label="Company Name" />
            <div>
              <label className="text-md text-darkBlack mb-1 font-semibold block">
                Company Type
              </label>
              <Select
                name="companyType"
                placeholder="Select Company Type"
                optionFilterProp="label"
                onChange={(value) => {
                  registerFormik.setFieldValue('companyType', value)
                  // If the user selects anything except 'other', clear the custom field
                  if (value !== 'other') {
                    registerFormik.setFieldValue('customCompanyType', '')
                  }
                }}
                status={
                  registerFormik.touched.companyType && registerFormik.errors.companyType
                    ? 'error'
                    : 'success'
                }
                options={[
                  {
                    value: 'financialRegulator',
                    label: 'Financial Regulator'
                  },
                  {
                    value: 'publiclyListedCompany',
                    label: 'Publicly listed company'
                  },
                  {
                    value: 'advertisingWatchdog',
                    label: 'Advertising watchdog'
                  },
                  {
                    value: 'ngo',
                    label: 'NGO'
                  },
                  {
                    value: 'other',
                    label: 'Other'
                  }
                ]}
                className="w-full"
              />
            </div>

            {/* CONDITIONAL INPUT: Only shows if "other" is selected */}
            {registerFormik.values.companyType === 'other' && (
              <InputText name="customCompanyType" label="Please specify" />
            )}

            <InputB2CRole name="b2cRole" />
            <FilledSuccessButton type="submit" isLoading={isLoading}>
              Sign up
            </FilledSuccessButton>
            <div className="flex items-center justify-center">
              Already have an account?
              <Link className="pl-1 text-primary underline" to={ROUTES.login}>
                Login
              </Link>
            </div>
          </div>
        </Form>
      </FormikProvider>
    </AuthPageContainer>
  )
}
